import React from "react";
import arrowNext from "../../assets/images/arrowNext.png"

function Entry({
  title,
  id,
  slug,
  excerpt,
  setShowEntryList,
  logo,
  baseUrl,
  setShowIframeUrl,
  setShowHeart,
  setEntryId,
  renderMode,
  content,
  publishedAt
}) {
  const shortExcerpt = excerpt.slice(0, 40) + "...";
  const shortTitle = title.slice(0, 40) + "...";

  // let iframeUrl = "";
  // if (
  //   slug
  //     .replace(/^https?\:\/\//i, "")
  //     .includes(baseUrl.replace(/^https?\:\/\//i, ""))
  // ) {
  //   iframeUrl = slug;
  // } else {
  //   iframeUrl = baseUrl + slug;
  // }

  let iframeUrl = "";

  if (slug.startsWith("http://") || slug.startsWith("https://")) {
    iframeUrl = slug;
  } else {
    iframeUrl = baseUrl.replace(/\/$/, "") + "/" + slug.replace(/^\//, "");
  }

  console.log("slug:", slug);
console.log("baseUrl:", baseUrl);

  const isStandalone =
    window.navigator.standalone === true ||
    window.matchMedia("(display-mode: standalone)").matches;

  const openNewsModal = (iframeUrl) => {
    return (e) => {
      e.preventDefault();

      if (renderMode === "redirect") {
        window.open(iframeUrl, "_blank", "noopener,noreferrer");
        return;
      }

      setShowHeart(true);
      setEntryId(id);

      if (renderMode === "html") {
        setShowIframeUrl({
          type: "html",
          content,
          title,
          publishedAt
        });
      } else {
        setShowIframeUrl({
          type: "iframe",
          url: iframeUrl
        });
      }

      setShowEntryList(false);
    };
  };

  const stripHtml = (html) => {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const innerContent = (
    <>
      <img
        src={logo}
        alt="Category Image"
        className="feed-item-image"
      />
      <div className="feed-info">
        <p className="feed-title">{shortTitle}</p>
        <p className="feed-desctiption">{stripHtml(shortExcerpt)}</p>
      </div>
      <img
        src={arrowNext}
        className="feed-item-icon"
      />
    </>
  );

  if (renderMode === "redirect" && isStandalone) {
    return (
      <a
        href={iframeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="feed-item"
      >
        {innerContent}
      </a>
    );
  }

  return (
    <div
      onClick={openNewsModal(iframeUrl)}
      className="feed-item"
    >
      {innerContent}
    </div>
  );
}

export default Entry;